import React, { useState, useEffect } from "react";
import Autocomplete from "react-autocomplete";
export const AutocompleteDiaChiGiaoHang = ({ dataBanHang, setDataBanHang, disEditKH }) => {
    const [value, setValue] = useState("");

    const [autocompleteData, setAutocompleteData] = useState([]);

    useEffect(() => {
        if (dataBanHang.ListAddress.length > 0) {
            setAutocompleteData(dataBanHang.ListAddress);
        }
    }, []);

    const onSelectCustomer = (value, item) => {
        setDataBanHang({
            ...dataBanHang,
            DiaChiGiaoHang: item.Addres,
        });
        setAutocompleteData([]);
    };

    const onChange = (field) => (e) => {
        setDataBanHang({
            ...dataBanHang,
            [field]: e.target.value,
        });
        setAutocompleteData([]);
        if (dataBanHang.ListAddress.length > 0) {
            setAutocompleteData(dataBanHang.ListAddress);
        }
    };

    return (
        <>
            <Autocomplete
                wrapperProps={{}}
                wrapperStyle={{ position: "relative", width: "100%" }}
                inputProps={{
                    className: "form-control input-sm card-autocomplete",
                    readOnly: disEditKH,
                    //   placeholder: "Nhập tên nhà cung cấp",
                }}
                menuStyle={{
                    borderRadius: "3px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "2px 0",
                    fontSize: "100%",
                    position: "absolute",
                    overflow: "auto",
                    maxHeight: "250px",
                    lineHeight: "30px",
                    top: "0 !important",
                    left: "0 !important",
                    zIndex: "1000",
                }}
                getItemValue={(item) => item.Addres}
                items={autocompleteData}
                renderItem={(item, isHighlighted) => {
                    return (
                        <div
                            className="auto-list"
                            style={{
                                background: isHighlighted ? "lightgray" : "white",
                                textTransform: "capitalize",
                            }}
                        >
                            {item.Addres}
                        </div>
                    );
                }}
                value={dataBanHang.DiaChiGiaoHang}
                onSelect={(value, item) => {
                    onSelectCustomer(value, item);
                }}
                onChange={onChange("DiaChiGiaoHang")}
            />
        </>
    );
};
